/**
 * Clean value-axis ticks for the Reporting charts: zero, then even steps of
 * 1, 2, 2.5, or 5 x 10^n, so a label reads `500K / 1M / 1.5M`, never
 * `650K / 1.3M / 2M` (data-visualization.md §4: round axis labels to clean
 * numbers). Values are non-negative here: balances, payouts, and rates.
 */
const STEPS = [1, 2, 2.5, 5, 10];

export function niceTicks(max: number, targetCount = 4): number[] {
    if (!Number.isFinite(max) || max <= 0) return [0, 1];
    const rough = max / targetCount;
    const magnitude = 10 ** Math.floor(Math.log10(rough));
    const step = (STEPS.find((s) => s * magnitude >= rough) ?? 10) * magnitude;
    const count = Math.ceil(max / step);
    // Rebuild from integer multiples so 0.1-style steps don't drift.
    return Array.from({ length: count + 1 }, (_, i) => Number((i * step).toPrecision(12)));
}
